export function isElementBelowTheFirstViewport(element: HTMLElement) {
  return element.offsetTop >= window.innerHeight;
}
